import React, { useEffect } from 'react';
import {
  Navigate,
} from 'react-router-dom';

function AdminRedirect() {
  const adminUrl = import.meta.env.VITE_URL || 'http://localhost:1337/';
  useEffect(() => {
    window.location.href = adminUrl + 'admin';
  }, [adminUrl]);
  return <Navigate to={adminUrl + 'admin'} relative={false} />;
}

export default AdminRedirect;
